/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import { Component, createRef } from 'react';
import { connect } from 'react-redux';
import store from 'features/store';
import moment from 'moment';
import * as momentTz from 'moment-timezone';
import { Button, Form, Modal } from 'react-bootstrap';

// project imports
import { MyAccountMenuList, ToggleSideBar } from '../MyAccountMenuList';
import { invoiceList } from 'shared/settings/apiconfig';
import Datatable from 'shared/datatable';
import { InvoiceService } from 'shared/services';

//style imports
import './InvoiceList.scss';



/**


@Author Narmadha

@param

@return html code for invoice list

**/

class InvoiceList extends Component {
    config;
    status = { 'paid': 'text-success', 'unpaid': 'text-danger' };
    search
    constructor(props) {
        super(props);
        this.dataTable = createRef();
        this.initialSearchState = {
            title: { field: 'saletitle', value: '', op: 'LIKE', join: 'AND' },
        }
        const searchState = JSON.parse( JSON.stringify(this.initialSearchState));
        this.state = {
            pageLoading: false,
            search: searchState,
            filterSearch: {},
            searchData: false,
            tableData:[],
            bidConfirmModal: false,
            itemReceiptValue: '',
            showReceipt: false,
            optionData: []
        }
        this.config = {
            url: `${invoiceList}`,
            params: {},
            columns: [
                { name: '', property: 'id', columnType: 'custom', actions: ['view'], customHeader: 'Actions', width: '60px', customColumn: this.customViewButton },
                { name: 'Item Receipt Method', property: 'itemreceiptmethod', sort: true, width: '180px', columnType: 'custom', customColumn: this.customItemReceipt },
                { name: 'Sale Title', property: 'saletitle', sort: true, width: '290px' },
                { name: 'Invoice ID', property: 'invoicenumber', sort: true, width: '130px', columnType: 'custom', customColumn: this.customInvoiceView },
                { name: 'Location', property: 'locationtitle', sort: true, width: '250px' },
                { name: 'Date', property: 'createddate', sort: true, width: '180px', columnType: 'custom', customColumn: this.customDate },
                { name: 'Status', property: 'invoicestatus', sort: true, width: '130px', columnType: 'custom', customColumn: this.customStatus },
                { name: 'Amount', property: 'invoiceamount', sort: true, width: '130px', columnType: 'custom', customColumn: this.customAmount },
                { name: 'Pending Amount', property: 'pendingamount', sort: false, width: '140px', columnType: 'custom', customColumn: this.customPendingAmount },
                // { name: '', property: 'id', width: '60px', columnType: 'invoiceViewButton',actions: ['view'], customColumn: this.customViewButton,
                // actionEvents: { view: (invoiceId) => { this.props.history.push(`/my-account/invoice/${invoiceId}/view`) } } },
            ],
            field: ["id", "avalitemreceiptmethod", "invoiceitemreceiptmethod", "invoiceview", "saletitle", "invoicenumber", "locationid", "locationtitle", "createddate", 
                "timezonename", "invoicestatus", "pendingamount", "invoiceamount", "type"],
            sort: [{ field: 'createddate', direction: 'desc' }],
            pagination: true,
            service: 'BUYER'
        }; 

        if (props.location.state && props?.location?.state?.datatable?.datatable  && props?.location?.state?.datatable?.datatable?.search) {
            let tempSearch = { ...this.initialSearchState };
            const search = [...props?.location?.state?.datatable?.datatable?.search];

            search.forEach(element => {
                let temp = { ...element };
                if (typeof temp['value'] === 'string') {
                    temp['value'] = temp['value'].replace(/(^\%)|(\%$)/g, '');
                }
                tempSearch['title'] = temp;
            });

            this.state['search'] = tempSearch;
            this.state['searchData'] = true;
          
        }

        this.dataTable = createRef();        
    }

    componentDidMount() {
        store.dispatch({ type: 'SIDEBAR_MENU_LIST', payload: { menuList: MyAccountMenuList(), withSpan: false } });
        this.windowResizeHandle();
        window.addEventListener('resize', this.windowResizeHandle);
        // window.history.pushState(null, null, window.location.pathname);
    }

    componentDidUpdate() {
        // window.addEventListener('resize', this.windowResizeHandle);
    }

    customStatus = (values) => {
        return (<span className={`${this.status[values['invoicestatus'].toLowerCase()]}`}>{values['invoicestatus']}</span>);
    }

    customAmount = (values) => {
        return (<span>${parseFloat(values['invoiceamount']).toFixed(2)}</span>);
    }

    customPendingAmount = (values) => {
        return (<span>${values['pendingamount'] ? parseFloat(values['pendingamount']).toFixed(2) : "0.00"}</span>);
    }

    customViewButton = (values) => {
        return (
            <Button
                className={`${values['invoicestatus'] === "UnPaid" ? 'unpaid-button' : `${values['invoicestatus'] === "Paid" ? 'paid-button': `${values['invoicestatus'] === "Void" ? 'void-button' : values['pendingamount'] <= 0 ? 'unpaid-button' : 'pay-button'}`}`}`}
                onClick={() => this.handleInvoiceClick(values)} aria-label='invoice view'>
                {values['invoicestatus'] === "Paid" || values['invoicestatus'] === "Void" || values['pendingamount'] <= 0 ? "View" : "View"}
            </Button>
        );
    }
    customInvoiceView = (values) => {
        return (<span style={{ color: "blue", cursor: "pointer" }} onClick={() => this.handleInvoiceClick(values)}>{values['invoicenumber']}</span>);
    }

    handleInvoiceClick = (values) => {
        const { history } = this.props;
        let data = {}
        data['datatable'] = this.state.tableData;

        if (values['type'] === "RA") {
            history.push({
                pathname: `/my-account/invoice/ra/${values['id']}/view`,
                state: data
            });
        } else if (values['type'] === "DG") {
            history.push({
                pathname: `/my-account/invoice/dg/${values['id']}/view`,
                state: data
        });
        } else {
            history.push({pathname: `/my-account/invoice/${values['id']}/view`,
            state: data
        });
        }
    };

    customDate = (value) => {
        if (value['createddate']) {
            return `${moment.utc(value['createddate']).local().format('MM/DD/YYYY hh:mm A')} ${momentTz.tz(momentTz.tz.guess()).zoneAbbr()}`;
        }
        return '- - -';
    };
    customItemReceipt = (values) => {
        var availOptionData = []
        if(values['avalitemreceiptmethod']){
            let availItemOption = JSON.parse(values['avalitemreceiptmethod']);
            if(Array.isArray(availItemOption)){
                availItemOption = availItemOption[0]
            }
            Object.entries(availItemOption).map(([key, value]) => {
                if (value == true)
                    availOptionData.push(key)
            })
        }  
        return (
            !values['invoiceview'] ?  <div className="itemreceipt-enable">none</div>  :
            values['invoiceitemreceiptmethod'] ? <div className="itemreceipt-disable">{values['invoiceitemreceiptmethod']}</div> :
            ( availOptionData.length == 0 || (!values['invoiceitemreceiptmethod'] && !values['avalitemreceiptmethod']) ) ?
            <div className="itemreceipt-enable">none</div> :
            <div className="itemreceipt-enable" onClick={()=> {this.openReceipt(availOptionData, values['id'])}}>select</div>
            );
    }

    openReceipt = (data, invoiceId) => {
        this.setState({
            bidConfirmModal: true,
            optionData: data,
            invoiceId: invoiceId
        })
    }

    onChangeOption = (event, invoiceId) => {
        this.setState({
            itemReceiptValue: event.target.value,
            invoiceId: invoiceId
        })
    }
    closeConfirmModal = () => {
        this.setState({
            itemReceiptValue: '',
            bidConfirmModal: false
        })
    }

    updateReceipt = (invoiceId, itemReceipt) => {
        return InvoiceService.receiptUpdate(invoiceId, {data: {"invoiceItemReceiptMethod": itemReceipt}}).then(data => {
            this.closeConfirmModal();
            this.searchData();
            return data;
        }).catch(error => {
            if (error.status === 503) {
                this.serviceDown();
            }
            return;
        });
    }
    /* called when search button clicked */
    enableSearch = (event) => {
        this.setState({
            search: {
                ...this.state.search,
                title: {
                    ...this.state.search.title,
                    value: event.target.value
                }
            }

        }, () => {
            let search = {};
            search = {
                title: { ...this.state.search.title, value: this.state.search.title.value ? '%' + this.state.search.title.value + '%' : '' },
            }
            this.setState({
                filterSearch: search,
                searchData: true
            });
        });

    }
    updateTableData = (event) => {
        this.setState({
            ...this.state,
            tableData: event,
        });
    }

    resetState = () => {
        this.setState({
            filterSearch: {},
            searchData: false,
            search: {
                ...this.state.search,
                title: {
                    ...this.state.search.title,
                    value: ""
                }
            }
        }, () => {
            this.searchData();
        });
    }

    searchData = (event = null) => {
        if (event) {
            event.preventDefault();
        }
        this.dataTable.current.searchData();
    }

    windowResizeHandle = () => {
        ToggleSideBar();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.windowResizeHandle);
        store.dispatch({ type: 'SET_SIDEBAR', payload: false });

        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state, callback) => {
            return;
        };
    }

    render() {
        return (
            <div className="invoice-list-main top-border">
                {
                    this.state.pageLoading ?
                        <div className="loader d-flex align-items-center justify-content-center">
                            <img src={`${process.env.PUBLIC_URL}/static/icons/table/loader.gif`} className="loader-icon" alt="loader-icon"></img>
                        </div> :
                        <div className="main-content w-100">
                            <form>
                                <div className="filter-section d-flex">
                                    <div className={`search-box`}>
                                        <div className="input-group">
                                            <input className="form-control" id="invoice-sale-search-input" aria-label='Search by sale title' placeholder="Search by sale title" onChange={this.enableSearch} value={this.state.search.title.value}></input>
                                            <span className="input-group-append align-items-center clickable" onClick={this.searchData}>
                                                <i className="fa fa-search"></i>
                                            </span>
                                        </div>
                                    </div>
                                    <Button className="clear-button ml-1" type="button" onClick={() => this.resetState()}>Clear All</Button>
                                    <Button variant=""   type="submit" className="mx-2 invoice-search" onClick={this.searchData}>Search</Button>
                                </div>
                            </form>
                            <div className="table-section">
                                <Datatable {...this.props}  config={{ ...this.config }} onDataUpdate={this.updateTableData} search={this.state.searchData ? { search: { ...this.state.filterSearch }, searchData: this.state.searchData } : null} ref={this.dataTable} />
                            </div>
                        </div>
                }
                <Modal centered show={this.state.bidConfirmModal} animation={false} backdrop="static" keyboard={false}>
                    <Modal.Body>
                        <div className="receipt-header text-center">
                            Please select an item receipt method
                        </div>
                        <div className="body-content">
                            <div className="align-items-ccenter justify-content-between">
                                <Form.Group className="d-flex multiple-checkbox center-align">
                                    {this.state.optionData.map((elem, index)=>{
                                        return <Form.Check custom type="radio" style={{ marginRight: "10px"}} id={elem} name="invoiceItemReceipt" label={elem} value={elem} onChange={(event) => this.onChangeOption(event, this.state.invoiceId)} />
                                    })}
                                </Form.Group>
                                <div>
                                { this.state.itemReceiptValue.toLowerCase() == 'shipping' ? 
                                    <p className="text-muted text-center">
                                        You have selected <b>{this.state.itemReceiptValue}</b> as your Item Receipt Method. 
                                        Once confirmed, selections cannot be changed. 
                                        Seller to reach out to coordinate shipping and secure payment.
                                    </p> : 
                                    this.state.itemReceiptValue.toLowerCase() == 'pickup' ?
                                    <p className="text-muted text-center">You have selected <b>{this.state.itemReceiptValue}</b> as your Item Receipt Method. 
                                        Once confirmed, selections cannot be changed. 
                                        Please refer to Receipt for Pickup details</p> : 
                                    this.state.itemReceiptValue.toLowerCase() == 'delivery' ?    
                                    <p className="text-muted text-center">You have selected <b>{this.state.itemReceiptValue}</b> as your Item Receipt Method. 
                                    Once confirmed, selections cannot be changed. 
                                    Seller to reach out to coordinate delivery and secure payment.</p> : ''
                                }
                                </div>
                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-center mt-4 actions">
                            <Button variant="outline-dark btn-white mx-2" onClick={() => this.closeConfirmModal()}>Cancel</Button>
                            <Button variant="secondary mx-2" onClick={() => this.updateReceipt(this.state.invoiceId, this.state.itemReceiptValue)}>Confirm</Button>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

export default connect(state => state)(InvoiceList);